module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-tabs', {
    attrs: {
      "color": "#fff",
      "border": true,
      "title-active-color": "#5878FA",
      "title-inactive-color": "#979797",
      "sticky": ""
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "产品介绍"
    }
  }, _vm._l((_vm.src), function(item, index) {
    return _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item,
        "alt": "产品介绍"
      }
    })
  }), 0), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "质量承诺"
    }
  }, [_c('static-doc')], 1), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "产品手册"
    }
  }, [_c('pdf-list', {
    attrs: {
      "type": 1
    }
  })], 1), _vm._v(" "), _c('van-tab', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "用户评论"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("用户评论暂未开放")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c2c2af0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/Proteomics/components/ProteomicsDesc.vue
// module id = 1557
// module chunks = 8